import { gql } from '@apollo/client';

export const DOWNLOAD_DOCUMENT_FILE = gql`
  query($documentId: ID!, $fileType: DocumentFileTypeEnum!) {
    downloadDocumentFile(document: $documentId, fileType: $fileType)
  }
`;
